<template>
    <q-input
        :model-value="formattedDate"
        :disable="disable"
        filled
        dense
        :placeholder="$t('pick_a_date')"
        @click="showCalendar = true"
    >
        <template #prepend>
            <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                    ref="qDateProxy"
                    v-model="showCalendar"
                    transition-show="scale"
                    transition-hide="scale"
                    @before-hide="beforeCalendarHide"
                >
                    <q-date
                        v-model="innerDate"
                        mask="YYYY-MM-DD HH:mm:ss"
                        @update:model-value="qDateProxy.hide()"
                    >
                        <div class="row items-center justify-end">
                            <q-btn
                                v-close-popup
                                type="button"
                                label="Close"
                                color="primary"
                                flat
                            />
                        </div>
                    </q-date>
                </q-popup-proxy>
            </q-icon>
            <q-icon v-if="time" name="schedule" class="cursor-pointer">
                <q-popup-proxy
                    v-model="showTimePicker"
                    transition-show="scale"
                    transition-hide="scale"
                >
                    <q-time v-model="innerDate" mask="YYYY-MM-DD HH:mm:ss">
                        <div class="row items-center justify-end">
                            <q-btn
                                v-close-popup
                                type="button"
                                label="Close"
                                color="primary"
                                flat
                            />
                        </div>
                    </q-time>
                </q-popup-proxy>
            </q-icon>
        </template>

        <template #append>
            <q-icon v-if="innerDate" name="cancel" color="grey-6" @click="innerDate = null" />
        </template>
    </q-input>
</template>

<script setup>
import { longDate, longDateTime, sqlDate, sqlTimestamp, toUTC, toLocalTime } from 'src/utils/formats.js'
import { computed, ref } from 'vue'
import { isObject } from 'lodash-es'

const props = defineProps({
    modelValue: [String, Object], // SQL date string or dayjs object
    time: Boolean, // Allow time selection?
    disable: Boolean,
})
const emit = defineEmits(['update:model-value'])
const qDateProxy = ref()
const showCalendar = ref(false)
const showTimePicker = ref(false)
const emitAsObject = isObject(props.modelValue) // If we were supplied an object then return an object

const innerDate = computed({
    get: () => {
        if (!props.modelValue) return null
        if (props.time) return sqlTimestamp(toLocalTime(props.modelValue)) // Get the date time as local time
        return sqlTimestamp(props.modelValue)
    },
    set: val => {
        if (!val) return emit('update:model-value', null)
        let emitValue = emitAsObject
            ? dayjs(val)
            : props.time ? sqlTimestamp(toUTC(val)) : sqlDate(val) // Set the date time (sqlTimestamp) to UTC for serialize
        emit('update:model-value', emitValue)
    },
})

const formattedDate = computed(() => {
    if (!innerDate.value) return null
    return props.time
        ? longDateTime(innerDate.value)
        : longDate(innerDate.value)
})
function beforeCalendarHide() {
    // Auto switch to the time picker?
    if (props.time) showTimePicker.value = true
}
</script>
